export default function FontAwesomeIcon({ name, scale, className, ...props }) {
  const localClassName = [
    "fa",
    (!!name && `fa-${name}`) || "",
    (!!scale && `fa-${scale}`) || "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  return <i className={localClassName}></i>;
}

FontAwesomeIcon.defaultProps = {
  className: "",
};
